/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Ai_Draft_HintInputs */

const en_us2_coaching_ai_draft_hint = /** @type {(inputs: Coaching_Ai_Draft_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The AI reads the student's history and builds a draft. It shows up here for you to review and approve; nothing changes for the student before that.`)
};

const pt_br2_coaching_ai_draft_hint = /** @type {(inputs: Coaching_Ai_Draft_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A IA lê o histórico do aluno e monta um rascunho. Ele aparece aqui para você revisar e aprovar; nada muda para o aluno antes disso.`)
};

const pt_pt2_coaching_ai_draft_hint = /** @type {(inputs: Coaching_Ai_Draft_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A IA lê o histórico do aluno e monta um rascunho. Ele aparece aqui para você revisar e aprovar; nada muda para o aluno antes disso.`)
};

/** @type {(inputs: Coaching_Ai_Draft_HintInputs) => LocalizedString} */
const es_419_coaching_ai_draft_hint = en_us2_coaching_ai_draft_hint;

/** @type {(inputs: Coaching_Ai_Draft_HintInputs) => LocalizedString} */
const fr_fr2_coaching_ai_draft_hint = en_us2_coaching_ai_draft_hint;

/** @type {(inputs: Coaching_Ai_Draft_HintInputs) => LocalizedString} */
const de_de2_coaching_ai_draft_hint = en_us2_coaching_ai_draft_hint;

/** @type {(inputs: Coaching_Ai_Draft_HintInputs) => LocalizedString} */
const it_it2_coaching_ai_draft_hint = en_us2_coaching_ai_draft_hint;

/**
* | output |
* | --- |
* | "The AI reads the student's history and builds a draft. It shows up here for you to review and approve; nothing changes for the student before that." |
*
* @param {Coaching_Ai_Draft_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_ai_draft_hint = /** @type {((inputs?: Coaching_Ai_Draft_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Ai_Draft_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_ai_draft_hint(inputs)
	if (locale === "es-419") return es_419_coaching_ai_draft_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_ai_draft_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_ai_draft_hint(inputs)
	if (locale === "de-DE") return de_de2_coaching_ai_draft_hint(inputs)
	if (locale === "it-IT") return it_it2_coaching_ai_draft_hint(inputs)
	return en_us2_coaching_ai_draft_hint(inputs)
});
export { coaching_ai_draft_hint as "coaching.ai_draft_hint" }